import React, { Component } from 'react'

export default class Blank extends Component {
    render() {
        return (
            <div style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
                <h1>You have successfully registered</h1>
                <h3>
                    <a href="https://user-hendrayfinvest.netlify.app/">Login</a>
                </h3>
            </div>
        )
    }
}